import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#FFFFFF',
      light: '#5BDCDF',
      dark: '#FFFFFF',
    },
    secondary: {
      main: '#7C7879',
      light: '#7C7879',
      dark: '#5BDCDF',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#F5FEFD',
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        padding: '20px 10px',
        margin: '10px',
        backgroundColor: '#fff', // 5d737e
      },
    },
    MuiButton: {
      root: {
        margin: '5px',
      },
    },
  },
});
export default theme;